export default "__VITE_ASSET__C0DnBCq7__"